<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getForbiddenKeywords.length > 0 && $store.getters.getForbiddenKeywordsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'forbiddenKeywords_Id',
            'forbiddenKeywords_ForbiddenGoodsKeyword',
            'forbiddenKeywords_Status',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('forbiddenKeywords_Id.localization_value.value') }}</th>
            <th>{{ $t('forbiddenKeywords_ForbiddenGoodsKeyword.localization_value.value') }}</th>
            <th>{{ $t('forbiddenKeywords_Status.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getForbiddenKeywords" :key="index">
            <td>
              #{{item.id}}
            </td>

            <td>
              {{item.keyword}}
            </td>
            <td>
              <div v-if="item.is_enabled === '1'"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['forbiddenKeywords_Active'])"></div>
                <StatusIcoBtn class="mr-1" :type="'delivered'"/>
                {{ $t('forbiddenKeywords_Active.localization_value.value') }}
              </div>
              <div v-else
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['forbiddenKeywords_Inactive'])"></div>
                <StatusIcoBtn class="mr-1" :type="'cancel'"/>
                {{ $t('forbiddenKeywords_Inactive.localization_value.value') }}
              </div>
            </td>
            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_edit.localization_value.value')"
                            :type="'edit'"
                            @click.native="changeForbiddenKeywordsPopup(true, item.id)"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getForbiddenKeywords"
                 :key="index"
            >
              <ForbiddenKeywordsTableMobile
                      :item="item"
                      @changeForbiddenKeywordsPopup="changeForbiddenKeywordsPopup(true, item.id)"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getForbiddenKeywordsCommonList.next_page_url !== null && $store.getters.getForbiddenKeywords.length > 0"
                    @click.native="$emit('showMore')"
                    v-bind:class="{'disabled-btn' : $store.getters.getNextForbiddenKeywordsPage}"
                    :count="$store.getters.getForbiddenKeywordsCommonList.total - $store.getters.getForbiddenKeywordsForPage * $store.getters.getForbiddenKeywordsCommonList.current_page < $store.getters.getForbiddenKeywordsForPage ?
                    $store.getters.getForbiddenKeywordsCommonList.total - $store.getters.getForbiddenKeywordsForPage * $store.getters.getForbiddenKeywordsCommonList.current_page:
                    $store.getters.getForbiddenKeywordsForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getForbiddenKeywordsLoading === false && $store.getters.getForbiddenKeywords.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <ForbiddenKeywordsPopup
            v-if="isModalForbiddenKeywordsPopup"
            :itemId="itemId"
            :type="'update'"
            @reload="$emit('reload')"
            @close="changeForbiddenKeywordsPopup(false)"
    />
  </div>
</template>

<script>
  import StatusIcoBtn from "../../../../../../UI/status/StatusIcoBtn/StatusIcoBtn";
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import ForbiddenKeywordsPopup from "../../../../popups/ForbiddenKeywordsPopup/ForbiddenKeywordsPopup";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import ForbiddenKeywordsTableMobile from "./ForbiddenKeywordsTableMobile/ForbiddenKeywordsTableMobile";

  export default {
    name: "ForbiddenKeywordsTable",
    components: {
      ForbiddenKeywordsTableMobile,
      NoResult,
      StatusIcoBtn,
      ManagerButton,
      LinkButton,
      ShowMore,
      ForbiddenKeywordsPopup,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalForbiddenKeywordsPopup: false,

      }
    },

    methods: {
      changeForbiddenKeywordsPopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalForbiddenKeywordsPopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deleteForbiddenKeywords', id).then(response => {
            if (this._.has(response, 'data') && response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {
              this.openNotify('success', 'common_notificationRecordDeleted')
              this.$emit('reload')
            } else {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
